import { render, staticRenderFns } from "./InviteEmail.vue?vue&type=template&id=2bb8955c&"
import script from "./InviteEmail.vue?vue&type=script&lang=js&"
export * from "./InviteEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports